import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as OcorrenciaHttp from '../../../../services/api/https/picking/ocorrencia.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { MODELO_COLUNAS } from './ModalImportOcorrenciaEntrega'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_DELIVERY_OCCURRENCES: 'Adquirindo ocorrências de entrega',
}

const INITIAL_STATE = {
  ocorrenciasEntrega: [],
  selectedEmpresaID: '',
  selectedEmpresaName: '',
  modalEntrega: {
    show: false,
    data: null,
  },
  modalImportacao: {
    show: false,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  ocorrenciaEntregaFilter: '',
}

const INITIAL_DELIVERY_OCCURRENCE = {
  id: null,
  company_id: '',
  sigla: '',
  company_code: null,
  descricao: '',
  assoc_guilty_client: false,
  actived: true,
}

export default function useOcorrenciaEntrega() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getDeliveryOccurrences(empresaID) {
        OcorrenciaHttp.getOcorrencias(empresaID)
          .then(ocorrencias =>
            setState(prevState => ({
              ...prevState,
              ocorrenciasEntrega: ocorrencias,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      // Events
      onEmpresaChange(selectedEmpresa) {
        setState(prevState => ({
          ...prevState,
          selectedEmpresaID: selectedEmpresa.id,
          selectedEmpresaName: selectedEmpresa.name,
          loadingMessage: LOAD_MESSAGE.GET_DELIVERY_OCCURRENCES,
        }))
      },

      onBtnExportar(selectedEmpresaID, selectedEmpresaName, ocorrencias) {
        if (selectedEmpresaID === '')
          return setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione a empresa desejada',
          }))

        if (ocorrencias.length === 0)
          return setState(prevState => ({
            ...prevState,
            errorMessage: 'Não existem ocorrências cadastradas para a empresa selecionada',
          }))

        const data = [
          ...MODELO_COLUNAS,
          ...ocorrencias.map(ocorrencia => [
            ocorrencia.company_code || ocorrencia.sigla || '',
            ocorrencia.descricao,
            ocorrencia.assoc_guilty_client ? 1 : 0,
            ocorrencia.actived ? 1 : 0,
          ]),
        ]

        gerarArquivoExcel('Modelo', data, buildNomeArquivoExportacao(selectedEmpresaName))
      },

      onBtnNovoEntrega(selectedEmpresaID) {
        if (selectedEmpresaID !== '')
          setState(prevState => ({
            ...prevState,
            modalEntrega: {
              show: true,
              data: { ...INITIAL_DELIVERY_OCCURRENCE, company_id: selectedEmpresaID },
            },
          }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione a empresa desejada' }))
      },

      onModalEntregaClose() {
        setState(prevState => ({
          ...prevState,
          modalEntrega: { show: false, data: { ...INITIAL_DELIVERY_OCCURRENCE } },
        }))
      },

      onModalEntregaSave(ocorrencia) {
        setState(prevState => {
          const index = prevState.ocorrenciasEntrega.findIndex(o => o.id === ocorrencia.id)
          if (index !== -1) prevState.ocorrenciasEntrega[index] = ocorrencia
          else prevState.ocorrenciasEntrega.push(ocorrencia)
          return { ...prevState, modalEntrega: { show: false, data: null } }
        })
      },

      onBtnImportar() {
        setState(prevState => ({ ...prevState, modalImportacao: { show: true } }))
      },

      onModalImportacaoClose() {
        setState(prevState => ({ ...prevState, modalImportacao: { show: false } }))
      },

      onOcorrenciasImportadas() {
        setState(prevState => ({
          ...prevState,
          modalImportacao: { show: false },
          loadingMessage:
            prevState.selectedEmpresaID === ''
              ? prevState.loadingMessage
              : LOAD_MESSAGE.GET_DELIVERY_OCCURRENCES,
        }))
      },

      onDeliveryRowClicked(ocorrencia) {
        setState(prevState => ({ ...prevState, modalEntrega: { show: true, data: ocorrencia } }))
      },

      onChangeOcorrenciaEntregaFitler(value) {
        setState(prevState => ({ ...prevState, ocorrenciaEntregaFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}

// Helpers
function buildNomeArquivoExportacao(empresaName) {
  const empresa = (empresaName || '')
    .toString()
    .trim()
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, ' ')

  return empresa ? `OcorrenciasEntrega - ${empresa}.xlsx` : 'OcorrenciasEntrega.xlsx'
}
